import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { Player } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';
import { TrackingSampleModal } from '../screens/HomePage/components/TrackingSampleModal';
import { useState } from 'react';

interface ResultsPendingProps {
  title: string;
  videoSrc?: any;
  dark?: boolean;
  className?: string;
}

export const ResultsPending = ({
  title,
  videoSrc,
  className,
  dark = false,
}: ResultsPendingProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={cn(
          'flex items-center justify-center h-full',
          dark ? 'bg-black' : 'bg-white',
        )}
      >
        <div className="text-center max-w-72">
          {/* TODO: ADD Onclick func to sample tracker */}
          <div>
            <div className="mb-9 w-full h-full">
              <Player autoplay loop src={videoSrc} />
            </div>

            <h1 className={cn('typography-h1 text-secondary mb-9', className)}>
              {title}
            </h1>

            <div
              className="flex justify-center cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            >
              <p className={cn('typography-body text-tertiary', className)}>
                Track your kit's progress
              </p>
              <ChevronRightIcon className={cn('text-tertiary', className)} />
            </div>
          </div>
        </div>
      </div>
      <TrackingSampleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
